import React, { useState } from "react";
import Spinner from "../reusables/spinner";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import {
  unsuspend_user,
  unsuspend_supplier,
} from "../../redux/actions/adminActions";

function UnsuspendModal({
  show,
  handleClose,
  users,
  unsuspend,
  supplier,
  unsuspendSupplier,
  accessToken,
}) {
  const [isLoading, setIsLoading] = useState(false);

  const handleLoading = () => {
    setIsLoading(true);

    setInterval(() => {
      setIsLoading(false);
    }, 5000);
  };

  const handleUnsuspend = (id) => {
    handleLoading();
    if (supplier) {
      unsuspendSupplier(id, accessToken, handleClose);
    } else {
      unsuspend(id, accessToken, handleClose);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <div className="icon--tiny isClickable closeModal" onClick={handleClose}>
        <i class="ri-close-line sectionText--small"></i>
      </div>
      <div className="sectionHeight--mid center">
        <div className="w-100 vAlign">
          <h2 className="sectionText--mid">
            Are you sure you want to unsuspend{" "}
            {users.length > 1 ? "these" : "this"} user{users.length > 1 && "s"}?
          </h2>

          <div className="pt-3 center">
            {isLoading ? (
              <div className="center">
                <Spinner dark />
              </div>
            ) : (
              <div>
                <button
                  className="btn__filled mx-2 hasRadius"
                  onClick={handleClose}
                >
                  No, Cancel
                </button>
                <button
                  className="btn__transparent"
                  onClick={() => handleUnsuspend(users)}
                >
                  Yes, Unsuspend
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  unsuspend: (id, token, success) =>
    dispatch(unsuspend_user(id, token, success)),
  unsuspendSupplier: (id, token, success) =>
    dispatch(unsuspend_supplier(id, token, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UnsuspendModal);
